
import { defineComponent, PropType } from "vue";
import { MdModal, MdModalComponentMixin } from "@/components/md/MdDialog";
import { MdButton } from "@/components/md/MdButton";
import { useStore } from "@/store";
import { InboxStore, RootStore } from "@/store/constants";
import { MdInputField } from "@/components/md/MdInput";
import { MdTooltip } from "@/components/md/MdTooltip";
import { ITag, ITagColor } from "@/types/inbox/tags";
import { Validator } from "@/classes/validators/Validator";
import { TextValidator } from "@/classes/validators/TextValidator";
import { createTag } from "@/api/inbox/settings/tags/create";
import { updateTag } from "@/api/inbox/settings/tags/update";

export default defineComponent({
  name: "TagUpdateModal",
  mixins: [MdModalComponentMixin],
  components: {
    MdModal,
    MdButton,
    MdInputField,
    MdTooltip,
  },
  props: {
    tag: Object as PropType<ITag>,
  },
  data() {
    return {
      name: "",
      color: "grey",
    };
  },
  setup() {
    return {
      store: useStore(),
    };
  },
  watch: {
    tag() {
      if (!this.tag) return;
      this.name = this.tag.name;
      this.color = this.tag.color;
    },
  },
  computed: {
    colors(): { [key: string]: ITagColor } {
      return this.store.getters[InboxStore.Getters.GET_TAG_COLORS];
    },
    nameInput(): typeof MdInputField {
      return this.$refs.nameInput as typeof MdInputField;
    },
    nameValidator(): Validator {
      return new TextValidator(true);
    },
  },
  methods: {
    async updateTag() {
      this.nameInput.validate();
      if (!this.nameValidator.isValid()) return;
      this.setLoadingState(true);
      if (!this.tag || !this.tag.id) return;
      try {
        await updateTag(this.tag.id, this.name, this.color);
        this.store.dispatch(InboxStore.Actions.LOAD_TAGS);
        this.store.commit(RootStore.Mutations.SET_SNACKBAR, {
          state: "success",
          content: "Änderungen gespeichert",
        });
      } catch (err) {
        this.store.commit(RootStore.Mutations.SET_SNACKBAR, {
          state: "error",
          content: "Änderungen konnten nicht gespeichert werden",
        });
      }
      this.name = "";
      this.setLoadingState(false);
      this.close();
    },
  },
});
